import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { NDDDialogService } from '@ndk/ng-dialog';
import {
    Observable,
    of as observableOf,
} from 'rxjs';

import { NDDTranslationService } from '@ndk/ng-translation';

import {
    INDDFormsI18nServiceConfigResources,
    NDDFormsI18nService,
} from './ndd-ng-forms-i18n.service';
import { INDDForms } from './ndd-ng-forms.model';

/** Guard para alertar troca de rota quando o formulário for `dirty`. */
@Injectable()
export class NDDFormsGuardService implements CanDeactivate<INDDForms> {
    constructor(
        private formsI18n: NDDFormsI18nService,
        private translationService: NDDTranslationService,
        private dialogService: NDDDialogService,
    ) { }

    public canDeactivate(component: INDDForms): Observable<boolean> {
        // Caso o formulário seja `dirty`, exibe Dialog para confirmação da mudança de rota.
        if (component && component.form && component.form.dirty) {
            return this.dialogService.confirm({ message: this.message });
        }

        return observableOf(true);
    }

    private get message(): string {
        const canDeactivateMessage: string = (<INDDFormsI18nServiceConfigResources>this.formsI18n.config.resources).canDeactivateMessage;

        if (this.formsI18n.config.i18n) {
            return this.translationService.instant(canDeactivateMessage);
        }

        return canDeactivateMessage;
    }
}
